export default __webpack_public_path__ + "static/media/outline-people.e37b792e.svg";